import getLeaveModuleV2Config from '@apps-leave/lib/request/webapp/get-leave-module-v2-config';

export default async function checkIsLeaveManagementEnabled(): Promise<
  boolean
> {
  try {
    const { data, success } = await getLeaveModuleV2Config();

    if (success) {
      return !!data?.config?.leaveManagementEnabled;
    }
  } catch (e) {
    console.error(e);
    throw e;
  }

  return false;
}
